/* eslint-disable no-nested-ternary */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Button from '@tcp/core/src/components/common/atoms/Button';
import { routerPush } from '@tcp/core/src/utils';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import ACCOUNT_CONSTANTS from '@tcp/core/src/components/features/account/Account/Account.constants';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import internalEndpoints from '../../../../common/internalEndpoints';
import { ACCOUNT_ORDERS_LABEL } from '../../../../OrderDetails/container/OrderDetails.labels';
import { EmptyOrdersListLabels } from './EmptyOrdersList.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblShopNow,
} from '../../../../../../../utils/labels/globalGeneric.labels';

/**
 * This function will handle click to go to homepage
 * @param {} -
 */
const goToHomePage = () => {
  routerPush(internalEndpoints.shopNowPage.link, internalEndpoints.shopNowPage.path);
  return null;
};

/**
 * This component will render EmptyOrdersList component
 * @param { string, object }
 */
export const EmptyOrdersList = ({ className, fromOrderList, selectedYear, emptyLabel }) => {
  const clickEventdata = {
    customEvents: [],
    eventName: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationName.shop_orders,
    pageNavigationText: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationText.shop_orders,
  };

  const {
    lbl_orders_emptySupportingText: lblEmptyShoppingText,
    lbl_orderHistory_empty_orders_text2: lblEmptyOrdersText2,
    lbl_orderHistory_empty_orders_text3: lblEmptyOrdersText3,
  } = getLabelFromCopyOrFromTranslation(ACCOUNT_ORDERS_LABEL, EmptyOrdersListLabels);

  return (
    <BodyCopy className={className}>
      {fromOrderList ? (
        selectedYear?.pastOrder ? (
          <div className="elem-mt-MED empty-order-cont">
            <BodyCopy fontSize="fs16" component="span" fontFamily="secondary" fontWeight="regular">
              {emptyLabel({ selectedYear })}
            </BodyCopy>
          </div>
        ) : (
          <div className="elem-mt-MED empty-order-cont">
            <BodyCopy fontSize="fs16" component="span" fontFamily="secondary" fontWeight="regular">
              {lblEmptyOrdersText3}
            </BodyCopy>
            <BodyCopy fontSize="fs16" component="span" fontFamily="secondary" fontWeight="bold">
              {lblEmptyOrdersText2}
            </BodyCopy>
          </div>
        )
      ) : (
        <div>
          <BodyCopy
            dataLocator="orders-no-order-info"
            fontFamily="secondary"
            fontSize="fs14"
            component="p"
            fontWeight="semibold"
            className="elem-mt-LRG elem-mb-LRG"
          >
            {lblEmptyShoppingText}
          </BodyCopy>
          <Col
            colSize={{
              small: 6,
              large: 3,
              medium: 3,
            }}
          >
            <ClickTracker clickData={clickEventdata}>
              <Button
                buttonVariation="fixed-width"
                fill="BLUE"
                color="white"
                onClick={goToHomePage}
                data-locator="orders-shop-now-btn"
              >
                {getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_GENERIC_LABELS}.${lblShopNow}`,
                  GlobalGenericLabels
                )}
              </Button>
            </ClickTracker>
          </Col>
        </div>
      )}
    </BodyCopy>
  );
};

EmptyOrdersList.propTypes = {
  className: PropTypes.string,
  emptyLabel: PropTypes.func,
};

EmptyOrdersList.defaultProps = {
  className: '',
  emptyLabel: () => {},
};

export default EmptyOrdersList;
